import React from "react";
import "./AnnouncementModal.css";

const AnnouncementModal = ({ isOpen, onClose, title, description }) => {
  if (!isOpen) return null;

  return (
    <div className="announcement-modal-overlay" onClick={onClose}>
      <div
        className="announcement-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top Header Section */}
        <div className="announcement-header">
          <span className="announcement-label">Announcement!</span>
          <button className="announcement-close-btn" onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clipPath="url(#clip0_3503_8811)">
                <path
                  d="M1.14258 1.14288L14.8569 14.8572M14.8569 1.14288L1.14258 14.8572"
                  stroke="#A1A1A1"
                  strokeWidth="2.28571"
                  strokeLinecap="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_3503_8811">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>

        {/* Centered Dynamic Content Section */}
        <div className="announcement-body">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            className="announcement-icon"
          >
            <path
              d="M28.8008 55.2C28.8008 57.1096 29.5594 58.9409 30.9096 60.2912C32.2599 61.6414 34.0912 62.4 36.0008 62.4C37.9103 62.4 39.7417 61.6414 41.0919 60.2912C42.4422 58.9409 43.2008 57.1096 43.2008 55.2"
              stroke="#6B4FBB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M50.0072 8.93137C49.0459 8.38218 47.8236 8.71275 47.277 9.66972C46.7305 10.6267 47.0667 11.8477 48.028 12.3969L49.0176 10.6641L50.0072 8.93137ZM57.3022 21.6162C57.9039 22.5443 59.1438 22.813 60.0715 22.2163C60.9992 21.6196 61.2635 20.3835 60.6617 19.4554L58.982 20.5358L57.3022 21.6162ZM49.0176 10.6641L48.028 12.3969C51.4018 14.3244 54.6222 17.4827 57.3022 21.6162L58.982 20.5358L60.6617 19.4554C57.7066 14.8975 54.0461 11.2389 50.0072 8.93137L49.0176 10.6641Z"
              fill="#6B4FBB"
            />
            <path
              d="M11.869 20.2378C11.3871 21.2326 11.8023 22.4276 12.7966 22.907C13.7908 23.3864 14.9875 22.9686 15.4695 21.9738L13.6692 21.1058L11.869 20.2378ZM23.5268 11.6941C24.4125 11.0318 24.595 9.77868 23.9344 8.89505C23.2738 8.01142 22.0203 7.83194 21.1347 8.49417L22.3307 10.0941L23.5268 11.6941ZM13.6692 21.1058L15.4695 21.9738C17.6152 17.5452 20.4183 14.0184 23.5268 11.6941L22.3307 10.0941L21.1347 8.49417C17.4132 11.2767 14.2353 15.3539 11.869 20.2378L13.6692 21.1058Z"
              fill="#6B4FBB"
            />
            <path
              d="M18.3176 33.7263C18.3176 28.6007 20.1803 23.685 23.496 20.0606C26.8117 16.4362 31.3088 14.4 35.9979 14.4C40.6871 14.4 45.1841 16.4362 48.4999 20.0606C51.8156 23.685 53.6783 28.6007 53.6783 33.7263C53.6783 43.3412 55.7165 48.919 57.3372 51.979C57.5093 52.3049 57.6001 52.6745 57.6004 53.0508C57.6007 53.4271 57.5105 53.7969 57.3389 54.1231C57.1673 54.4493 56.9203 54.7205 56.6226 54.9095C56.325 55.0985 55.9871 55.1987 55.6428 55.2H16.3531C16.0092 55.1978 15.672 55.0969 15.375 54.9075C15.078 54.7181 14.8316 54.4468 14.6606 54.1208C14.4896 53.7947 14.3999 53.4253 14.4004 53.0494C14.4009 52.6736 14.4917 52.3045 14.6636 51.979C16.2818 48.919 18.3176 43.3385 18.3176 33.7263Z"
              stroke="#6B4FBB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          {/* Dynamic Content */}
          <h2 className="announcement-title">{title || "Title"}</h2>
          <p className="announcement-description">
            {description || "Description"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
